var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showform)?_c('div',[_c('transition',{attrs:{"name":"fade"}},[_vm._v(" "+_vm._s(_vm.$t('contacte[0].fraseformulari'))+" ")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }